const styles = (theme) => ({
  buttonText: {
    color: theme.palette.text.primary,
  },
});

export default styles;
